import React from 'react';
import InviteAgent from 'containers/Organizations/SingleOrganization/Agents/Invite';

export default {
  name: 'invite',
  path: /.*\/organizations\/\d+\/agents\/invite$/,
  component: <InviteAgent />,
};
